import { ConfirmationChannelEnum } from "./enums"

export class ConfirmationChannel {

    constructor();
    constructor(mask: string, channelEnum: number, value: string);

    constructor(mask?: string, channelEnum?: number, value?: string) {
        this.mask = mask ?? "";
        this.channelEnum = channelEnum ?? 0;
        this.value = value ?? "";
    }

    public id: number = 0;

    public mask: string = "";

    public channelEnum: number = 0;

    public value: string = "";
}